<script setup>
import { onMounted, ref } from 'vue'
import { Button } from '@components'


import { useRouter } from 'vue-router'
const router = useRouter()

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import AppointmentLoader from './AppointmentLoader.vue'
import AppointmentItem from './AppointmentItem.vue'
import Main from '../layout/Main.vue'

const state = ref({
    loaded: true
})


onMounted(() => {
    // state.value.loaded = false
    // setTimeout(() => {
    //     state.value.loaded = true
    // }, 1500)

})

const isAvailable = (type) => {
    if (!type || !$appointments.selectedService.booking_type) return false

    let available = $appointments.selectedService.booking_type.filter(el => el == type)
    return available.length ? true : false
}
</script>

<template>
    <Main slotContentClass="h-[calc(100%-67px)]">
        <template #content>
            <div class="appointment-page-title">Appointment type</div>

            <!-- empty appointment loader -->
            <AppointmentLoader v-if="!state.loaded" />
            <!-- appointment type list -->
            <div class="flex flex-col gap-3" v-if="state.loaded">
                <template v-for="(type, index) in $appointments.appointmentTypes" :key="index">
                    <AppointmentItem v-if="isAvailable(type.name)" :item="type" />
                </template>
            </div>
        </template>

        <template #footer v-if="state.loaded">
            <Button @click="$appointments.nextStep()" type="primary" size="md" radius="square" class="w-full">Continue</Button>
        </template>
    </Main>
</template>